module.exports = __webpack_public_path__ + "static/media/big-icon-home.8b3bd376.png";